(function($, undefined) {
	'use strict';

	var toggleElement = function() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (!el.length) {
			el = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
		}

		if (t.hasClass('close-all')) {
			$('.element-to-toggle').each(function() {
				if ($(this).attr('data-id') !== t.attr('data-id')) {
					$(this).slideUp();
				}
			});
		}
		
		el.each(function() {
			if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('required')) {
				$(this).find('input.required, select.required').removeClass('required').addClass('derequired').closest('.tmpl-form-input-big').removeClass('required').addClass('derequired');
			} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('derequired')) {
				$(this).find('input.derequired, select.derequired').removeClass('derequired').addClass('required').closest('.tmpl-form-input-big').removeClass('derequired').addClass('required');
			}

			if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('form-submit-input')) {
				$(this).find('input.form-submit-input, select.form-submit-input').removeClass('form-submit-input').addClass('no-submit-input');
			} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('no-submit-input')) {
				$(this).find('input.no-submit-input, select.no-submit-input').removeClass('no-submit-input').addClass('form-submit-input');
			}
		});

		if (ctn.length > 0) {
			ctn.toggleClass('open');
		} else {
			t.toggleClass('open');
		}
		el.slideToggle(function() {
			if ($(this).css('display') === 'none' && $(this).hasClass('empty-inputs-on-close')) {
				$(this).find('input, select').val('').removeClass('success error').closest('.tmpl-form-input-big').removeClass('success error');
			}
		});
	};

	var typeNumbersOnly = function(e) {
		var allowed = [0, 8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

		if ($(this).hasClass('phone')) {
			allowed.push(45);
		}

		if (!e.shiftKey && allowed.indexOf(e.which) !== -1) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	};

	var qtyInputChange = function() {
		var t = $(this);
		var number = parseInt(t.val());
		var min = parseInt(t.attr('min') || Number.MIN_SAFE_INTEGER);
		var max = parseInt(t.attr('max') || Number.MAX_SAFE_INTEGER);
		var minusBtn = t.closest('.qty-input-ctn').find('.qty-input-btn.minus');
		var plusBtn = t.closest('.qty-input-ctn').find('.qty-input-btn.plus');

		if (number <= min) {
			t.val(min);
			minusBtn.addClass('disabled').attr('disabled', true);
		} else {
			minusBtn.removeClass('disabled').removeAttr('disabled');
		}
		if (number >= max) {
			t.val(max);
			plusBtn.addClass('disabled').attr('disabled', true);
		} else {
			plusBtn.removeClass('disabled').removeAttr('disabled');
		}
	};

	var changeQty = function() {
		var t = $(this);
		var input = t.closest('.qty-input-ctn').find('.qty-input');
		var number = parseInt(input.val());

		if (t.hasClass('minus')) {
			input.val(number - 1);
		} else if (t.hasClass('plus')) {
			input.val(number + 1);
		}

		input.trigger('keyup');
	};

	
	var initQtyInputs = function (ctn) {
		ctn.on('keypress', 'input.numbers-only', typeNumbersOnly);
		ctn.on('keyup', 'input.qty-input', qtyInputChange);
		ctn.on('click', '.qty-input-btn', changeQty);
	};

	var init = function() {
		initQtyInputs($('body'));
		$('body').on('click', '.toggle-trigger-element:not(input[type=radio])', toggleElement);
		$('body').on('change', 'input[type=radio].toggle-trigger-element', toggleElement);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
